import { Spinner } from '@nextui-org/spinner';
import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { AuthGuard } from '@portal/components/AuthGuard';
import { TypographyUI } from '@portal/components/common/Typography.ui';
import { Layout } from '@portal/layout';
import { EncryptionStatus } from '@portal/views/encryption/EncryptionStatus';
import { Login } from '@portal/views/login';
import { Manage } from '@portal/views/manage';
import { Monitors } from '@portal/views/monitors';
import { Servers } from '@portal/views/servers';
import { Users } from '@portal/views/users';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthGuard>
        <Layout>
          {() => (
            <div className='flex w-full h-screen gap-4 items-center justify-center'>
              <div className='flex items-center gap-8'>
                <Spinner />
                <TypographyUI variant='h5' color='blue-gray'>
                  Your&apos;s server monitors
                </TypographyUI>
              </div>
            </div>
          )}
        </Layout>
      </AuthGuard>
    ),
  },
  {
    path: '/login',
    element: (
      <AuthGuard>
        <Layout>{() => <Login />}</Layout>
      </AuthGuard>
    ),
  },
  {
    path: '/encryption/status',
    element: (
      <AuthGuard>
        <Layout>{() => <EncryptionStatus />}</Layout>
      </AuthGuard>
    ),
  },
  {
    path: '/servers',
    element: (
      <AuthGuard requireAdmin>
        <Layout>{() => <Servers />}</Layout>
      </AuthGuard>
    ),
  },
  {
    path: '/monitors',
    element: (
      <AuthGuard>
        <Layout>{() => <Monitors />}</Layout>
      </AuthGuard>
    ),
  },
  {
    path: '/manage',
    element: (
      <AuthGuard requireSuperAdmin>
        <Layout>{() => <Manage />}</Layout>
      </AuthGuard>
    ),
  },
  {
    path: '/users',
    element: (
      <AuthGuard requireAdmin>
        <Layout>{() => <Users />}</Layout>
      </AuthGuard>
    ),
  },
]);
